import { render, staticRenderFns } from "./RadiantMediaPlayer.vue?vue&type=template&id=2b6bcae7&scoped=true&"
import script from "./RadiantMediaPlayer.vue?vue&type=script&lang=js&"
export * from "./RadiantMediaPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RadiantMediaPlayer.vue?vue&type=style&index=0&id=2b6bcae7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bcae7",
  null
  
)

export default component.exports